import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-panel m-panel--newsletter" }
const _hoisted_2 = { class: "m-panel__head" }
const _hoisted_3 = {
  key: 0,
  class: "m-panel__body"
}
const _hoisted_4 = { class: "m-panel__row" }
const _hoisted_5 = { class: "o-subscriptionForm" }
const _hoisted_6 = { class: "a-formField" }
const _hoisted_7 = ["value", "placeholder", "aria-label"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "m-formGroup__notice"
}
const _hoisted_10 = {
  key: 1,
  class: "m-panel__body"
}
const _hoisted_11 = { class: "m-panel__row" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconComponent, {
        "icon-id": _ctx.IconName.Interest
      }, null, 8, ["icon-id"])
    ]),
    (_ctx.subscription.displayState !== _ctx.SubscriptionState.SuccessfulRegistration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.subscription.interest.type === _ctx.InterestType.General)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _withDirectives(_createElementVNode("h2", null, null, 512), [
                    [_directive_translate, { key: _ctx.Translation.Interest_subscription_general_interest_title }]
                  ]),
                  _withDirectives(_createElementVNode("p", null, null, 512), [
                    [_directive_translate, { key: _ctx.Translation.Interest_subscription_general_interest_description }]
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.subscription.interest.type === _ctx.InterestType.Category || _ctx.subscription.interest.type === _ctx.InterestType.MainCategory)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _withDirectives(_createElementVNode("h2", null, null, 512), [
                    [_directive_translate, {
                        key: _ctx.Translation.Interest_subscription_category_interest_title,
                        keyValues: JSON.stringify({ 'tdlCategory': _ctx.subscription.interest.resourceName })
                    }]
                  ]),
                  _withDirectives(_createElementVNode("p", null, null, 512), [
                    [_directive_translate, {
                        key: _ctx.Translation.Interest_subscription_category_interest_description,
                        keyValues: JSON.stringify({ 'tdlCategory': _ctx.subscription.interest.resourceName })
                    }]
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.subscription.interest.type === _ctx.InterestType.Artist)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _withDirectives(_createElementVNode("h2", null, null, 512), [
                    [_directive_translate, {
                        key: _ctx.Translation.Interest_subscription_artist_interest_title,
                        keyValues: JSON.stringify({ 'artist': _ctx.subscription.interest.resourceName })
                    }]
                  ]),
                  _withDirectives(_createElementVNode("p", null, null, 512), [
                    [_directive_translate, {
                        key: _ctx.Translation.Interest_subscription_artist_interest_description,
                        keyValues: JSON.stringify({ 'artist': _ctx.subscription.interest.resourceName })
                    }]
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.subscription.interest.type === _ctx.InterestType.Venue)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _withDirectives(_createElementVNode("h2", null, null, 512), [
                    [_directive_translate, {
                        key: _ctx.Translation.Interest_subscription_venue_interest_title,
                        keyValues: JSON.stringify({ 'venue': _ctx.subscription.interest.resourceName })
                    }]
                  ]),
                  _withDirectives(_createElementVNode("p", null, null, 512), [
                    [_directive_translate, {
                        key: _ctx.Translation.Interest_subscription_venue_interest_description,
                        keyValues: JSON.stringify({ 'venue': _ctx.subscription.interest.resourceName })
                    }]
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("input", {
                  value: _ctx.subscription.user.email,
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.controller.updateStateEmail(($event.target as HTMLTextAreaElement).value))),
                  placeholder: _ctx.emailInputLabel,
                  "aria-label": _ctx.emailInputLabel,
                  class: "a-formInput",
                  name: "userEmail",
                  type: "email"
                }, null, 40, _hoisted_7)
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submitSubscription()), ["stop"])),
                class: _normalizeClass(["a-button -submit", [{ 
                            '-active': !_ctx.subscription.requestInProgress 
                                && _ctx.subscription.user.email !== null 
                                && _ctx.subscription.user.email.length !== 0 
                        }]]),
                type: "submit"
              }, [
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Notifications_subscribe }]
                ])
              ], 2),
              _createElementVNode("p", {
                innerHTML: _ctx.subscription.gdprNotice
              }, null, 8, _hoisted_8),
              (_ctx.subscription.displayState === _ctx.SubscriptionState.SubscriptionFailed)
                ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_9, null, 512)), [
                    [_directive_translate, { key: _ctx.Translation.Interest_subscription_error }]
                  ])
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.subscription.displayState === _ctx.SubscriptionState.SuccessfulRegistration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.subscription.interest.type === _ctx.InterestType.General)
              ? _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_12, null, 512)), [
                  [_directive_translate, { key: _ctx.Translation.Interest_subscription_general_success_title }]
                ])
              : _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_13, null, 512)), [
                  [_directive_translate, {
                    key: _ctx.Translation.Interest_subscription_success_title,
                    keyValues: JSON.stringify({ 'interestName': _ctx.subscription.interest.resourceName })
                }]
                ]),
            _withDirectives(_createElementVNode("p", null, null, 512), [
              [_directive_translate, {
                    key: _ctx.Translation.Interest_subscription_success_description,
                    keyValues: JSON.stringify({ 'userEmail': _ctx.subscription.user.email })
                }]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}